"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePrefersReducedMotion = usePrefersReducedMotion;
const react_1 = require("react");
/**
 * Hook to detect if the user prefers reduced motion.
 * Essential for accessibility - respects user's system preference.
 *
 * @returns Whether the user prefers reduced motion
 *
 * @example
 * ```tsx
 * function AnimatedComponent() {
 *   const prefersReducedMotion = usePrefersReducedMotion();
 *
 *   return (
 *     <motion.div
 *       initial={prefersReducedMotion ? false : { opacity: 0 }}
 *       animate={{ opacity: 1 }}
 *       transition={{ duration: prefersReducedMotion ? 0 : 0.5 }}
 *     >
 *       Content
 *     </motion.div>
 *   );
 * }
 * ```
 */
function usePrefersReducedMotion() {
    // Default to false if SSR
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        // Check for prefers-reduced-motion preference
        const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        setPrefersReducedMotion(mediaQuery.matches);
        // Add listener to update state when preference changes
        const handleChange = (e) => {
            setPrefersReducedMotion(e.matches);
        };
        mediaQuery.addEventListener('change', handleChange);
        return () => mediaQuery.removeEventListener('change', handleChange);
    }, []);
    return prefersReducedMotion;
}
